import { createContext, useContext } from 'react';
import type { AnnotatedBillingLine } from './billingLineSource';

export interface BillingLineActions {
  resetFixedServicePrice: (line: AnnotatedBillingLine) => void;
  /**
   * Take the user to the service's steps in the Works card, where the hours
   * and discounts of a combined labour line are edited (#2638). Absent when the
   * host page has no Works card to open.
   */
  openServiceLabor?: ((bookingServiceId: string) => void) | undefined;
}

const noopActions: BillingLineActions = {
  resetFixedServicePrice: () => undefined,
};

export const BillingLineActionsContext = createContext<BillingLineActions>(noopActions);

export function useBillingLineActions(): BillingLineActions {
  return useContext(BillingLineActionsContext);
}
